import Carousel from '../Carousel/carousel'
import ContactForm from '../ContactForm/index'
import Faq from '../Faq/index'
import ReferenceList from '../ReferenceList/referenceList'
import ProductTeaser from '../ProductTeaser/ProductTeaser'
import Hero from '../Hero/Hero'
import { Container, Button, Grid } from '@material-ui/core'
import React from 'react'
import RenderGate from '../RenderGate/renderGate'
import green1 from '../../media/projectImages/greeni-1.jpg'
import green2 from '../../media/projectImages/greeni-2.jpg'
import green3 from '../../media/projectImages/greeni-3.jpg'
import green4 from '../../media/projectImages/greeni-4.jpg'
import advGolf from '../../media/projectImages/adventure-golf.jpg'

const referenceImages = [green1, green2, green3, green4, green1, green2, green3, green4]
const referencesPerRow = 3;

// TODO: All the logic to render reference list could be refactored into its own component
class Home extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      referencesToShow: referenceImages.slice(0, referencesPerRow),
      next: 3,
      buttonVisible: true
    }

    this.handleShowMoreReferences = this.handleShowMoreReferences.bind(this)
  }

  loopWithSlice = (start, end) => {
    const slicedReferences = referenceImages.slice(start, end)

    this.setState({
      referencesToShow: [...this.state.referencesToShow, ...slicedReferences],
      buttonVisible: referenceImages[end] || referenceImages[end + 1]
    })
  }

  handleShowMoreReferences() {
    const end = this.state.next + referencesPerRow
    this.loopWithSlice(this.state.next, end)

    this.setState({
      next: this.state.next + referencesPerRow,
    })
  }

  render() {
    return (
      <Container disableGutters maxWidth={false}>
        <Hero />
        <ProductTeaser image={green3} heading='Golftekonurmi' description='Toteutamme viheriöasennuksia ympäri Suomen. Vuosien kokemus takaa kestävän harjoittelupaikan hankalimpaankin maastoon. Breikit ja kaadot rakennetaan asennusvaiheessa asiakkaan toiveiden mukaisiksi!' linkTo={'/artificial'} />
        <ProductTeaser image={green4} imageOnRight heading='Lyöntimatot ja lähipelialueet' description='InterGREENS-lyöntimattoa käytetään monella virallisella 18 reiän kentällä Suomessa lyöntipaikkanurmena.' linkTo={''} />
        <ProductTeaser image={advGolf} heading='Adventure golf' description='Adventure golf on uudenlainen tapa pelata golfia. Tarjoamme adventure golf -kentän suunnittelun sekä toteutuksen.' linkTo={''} />
        <ContactForm />
        {/* <Carousel className='swiper-carousel' images={referenceImages} />
        <Container className='reference-list' disableGutters maxWidth={false}>
          <h2>References</h2>
          <ReferenceList references={this.state.referencesToShow} />
          <RenderGate shouldRender={this.state.buttonVisible}>
            <Button className='show-more action-button' onClick={this.handleShowMoreReferences}>Show more</Button>
          </RenderGate>
        </Container>
        <Grid container>
          <Grid item xs={6} className='contact-form'>
            <ContactForm />
          </Grid>
          <Grid item xs={6} className='faq'>
            <Faq />
          </Grid>
        </Grid> */}
      </Container>
    )
  }
}

export default Home
